import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=73860aad&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=73860aad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73860aad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73860aad')) {
      api.createRecord('73860aad', component.options)
    } else {
      api.reload('73860aad', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=73860aad&scoped=true&", function () {
      api.rerender('73860aad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I50zaeURC6Je/JS/comp/PopupBox.vue"
export default component.exports